import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-link-enabled-dialog-box',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './link-enabled-dialog-box.component.html',
  styleUrl: './link-enabled-dialog-box.component.scss'
})
export class LinkEnabledDialogBoxComponent {


  constructor(
    private dialogRef: MatDialogRef<LinkEnabledDialogBoxComponent>,
  ) { }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
